export class UpdateView {
    constructor(
        public file_name: string,
        public file_content: string,
        public file_uuid: string,
        public hierarchy?: string,
        public model_UUID?: string
    ){}
}
